<script setup lang="ts">
import { computed, getCurrentInstance, nextTick, onMounted, ref, watch, watchSyncEffect } from "vue";
import { Drawer, type DrawerProps } from "@/components";
// import { DxDataGrid, DxLoadPanel } from 'devextreme-vue';
import { DxDataGrid, DxColumn, DxPager } from "devextreme-vue/data-grid";
import WrapperHead from "@/layouts/WrapperHead.vue";
import VisGrupo from "./Grupos.vue";
import type { CellTableActions } from "./types";
import { DxTextBox, DxValidator, DxButton, DxToolbar, DxValidationGroup } from 'devextreme-vue'


// #region PROPS
type Props = {
    mostrarBotaoNovo?: boolean;
    largura?: number;
    altura?: number;
    titulo: string;
    mostrarTitulo?: boolean;
    mostrarBotaoFechar?: boolean;
    mostrarBotaoConfirmar?: boolean;
    visivel?: boolean
    fecharAoClicarFora?: boolean
    // refModal: boolean;
    refGrid?: string;
    nomeController: string;
    grupoTemImagem?: boolean;
    allowColumnResizing?: boolean;
    allowUpdating?: boolean;
    allowDeleting?: boolean;
    allowAdding?: boolean;
    useIcons?: boolean;
    filterRowVisible?: boolean;
    pagingEnabled?: boolean;
    dados?: boolean;
};
const props = withDefaults(defineProps<Props>(), {
    mostrarBotaoNovo: true,
    largura: 500,
    altura: 500,
    // CORRIGIR
    // titulo: () => $vistra.globalize("grupos"),
    mostrarTitulo: true,
    mostrarBotaoFechar: true,
    mostrarBotaoConfirmar: true,
    visivel: false,
    fecharAoClicarFora: true,
    // refModal: 'modalGrupos',
    refGrid: "gridGrupos",
    grupoTemImagem: false,
    allowColumnResizing: true,
    allowUpdating: true,
    allowDeleting: true,
    allowAdding: false,
    useIcons: true,
    filterRowVisible: true,
    pagingEnabled: false
})

type EmitHandles = {
  (e: 'resetarVisibilidade'): boolean;
};
const emit = defineEmits<EmitHandles>();
const search = ({ value }: HTMLInputElement) => {
	refGrid.value.instance.searchByText(value)
};
// #endregion

// #region VARIAVEIS DATA
const app = getCurrentInstance()
const { $http, $vistra } = app!.appContext.config.globalProperties
const data = ref({
    grupoSelecionado: [],
    dataSource: [],
    mostrarGrupo: false,
    rowIndex: 0,
    botoes: [
        {
            widget: "dxButton", 
            location: "after", 
            toolbar: "top",
            options: {
                hint: $vistra.globalize("btn-novo"), 
                icon: "add",
                type: "default",
                visible: props.mostrarBotaoNovo,
                onClick: function() {
                    // CORRIGIR
                    // _this.$refs[_this.refGrid].instance.addRow();
                }
            }
        },
        {
            widget: "dxButton", 
            location: "after", 
            toolbar: "top",
            options: {
                hint: $vistra.globalize("btn-confirmar"), 
                icon: "check",
                visible: props.mostrarBotaoConfirmar,
                type: "default",
                onClick: function() {
                    // CORRIGIR
                    // _this.$refs.modalGrupos.hide();

                    if(props.dados) {
                        // CORRIGIR
                        // let grupoSelecionado = _this.$refs.gridGrupos.instance.getSelectedRowsData()[0]
                        // _this.dados.idGrupo = grupoSelecionado.id
                    }
                }
            }
        }
    ]
})
const colunas = ref();
const drawerGrupos = ref();
const refGrid = ref();
const validador = ref();
const drawerAddOrEditGrupo = ref();
const MAX_IMAGE_SIZE = ref(102400); // 100kb
const imagemEdicao = ref(); // 100kb

// #endregion

// #region METHODS and COMPUTED
const carregaGrupos = () => {
    $http
        .get(`/${props.nomeController}/GetGrupos`, { })
        .then(response => data.value.dataSource = response.data)
        .catch(e => $vistra.showMessage(!e.data.msgErro ? e : e.data.msgErro, "error"))     
}
const onInitNewRow = (e) => {
    data.value.grupoSelecionado = {
        id: -$vistra.randomInt(), //precisa ser negativo. No server side vai ver que precisa de um id novo do banco
        nome: ""
    }
    if(props.grupoTemImagem) {
        data.value.grupoSelecionado.imagem = ""
        data.value.mostrarGrupo = true;
    }
    drawerAddOrEditGrupo.value.toggle()
}
const onRowRemoving = (e) => {         
    $http
        .delete(`${props.nomeController}/DeleteGrupo/${e.data.id}`, {})
        .then(response => {
            if (response.data.msgErro) {
                $vistra.showMessage(response.data.msgErro, "error")
                return
            }
        $vistra.showMessage(response.data.msg)
        })
        .catch(e => {
            $vistra.showMessage(!e.data.msgErro ? e : e.data.msgErro, "error")
            e.cancel = true
        })
        .then(() => carregaGrupos() )
}
const onEditingStart = (e) => {
    if(props.grupoTemImagem) {
        data.value.mostrarGrupo = true;
        nextTick(() => refGrid.value?.instance?.cancelEditData())
    }
    drawerAddOrEditGrupo.value.toggle()
}
const onRowClick = (e) => {
    $vistra.dblclickEdicao(e)
}
const setColunas = () => {
    colunas.value = [
        {
            dataField: "nome",
            caption: $vistra.globalize("nome"),
            sortOrder: "asc",
            allowEditing: false
        }
    ]
    if(props.grupoTemImagem)
        colunas.value.unshift(
            {
                dataField: "imagem",
                caption: $vistra.globalize("imagem"),
                width: 90,
                allowFiltering: false,
                allowSorting: false,
                allowEditing: false,
                cellTemplate: function (container, options) {
                    if (!!options.value) {
                        let div = document.createElement("div")
                        div.setAttribute("class", "imagem-grupo")
                        div.innerHTML = `<img src='data:image/png;base64, ${options.value}' />`
                        container.appendChild(div)
                    }
                }
            },
        )
    colunas.value.push({
            caption: $vistra.globalize("acoes"),
            type: 'buttons',
            buttons: [
                {
                    name: 'editar',
                    icon: 'fal fa-pen',
                    onClick: (e) => {
                        data.value.grupoSelecionado = e.row.data;
                        if(e.row.data.id)
                            onEditingStart(e.row.data.id);
                    }
                },
                {
                    name: 'excluir',
                    icon: 'fal fa-trash-can',
                    onClick: (e) => {
                        onRowRemoving(e.row);
                    }
                }
            ]
    }); 
}
const onClick = (e) => {
    let input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/png");
    input.addEventListener('change', function (event) {
        let files = event?.target?.files;
        if (files.length > 0) {
            if (!files[0].type.match('image.png')) {
                $vistra.showMessage($vistra.globalize("formato-nao-suportado"), "error");
                return false;
            }
            let reader = new FileReader();
            reader.onload = ((theFile) => {
                return (e) => {                                
                    if (theFile.size > MAX_IMAGE_SIZE.value) {
                        $vistra.showMessage($vistra.globalize("tamanho-excedido", $vistra.formatBytes(MAX_IMAGE_SIZE.value, 0)), "warning");
                        return
                    }
                    data.value.grupoSelecionado.imagem = e?.target?.result?.replace("data:image/png;base64,", "");
                    if(imagemEdicao.value)
                        imagemEdicao.value.setAttribute("src", e?.target?.result);
                };
            })(files[0]);
            reader.readAsDataURL(files[0]);
        }
    });
    let simulateClick = function (elem) {
        let evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
        let canceled = !elem.dispatchEvent(evt);
    };
    simulateClick(input);
}
const salvarGrupo = () => {
    if (validador.value?.instance?.validate()?.isValid) {
        $http({
            method: data.value.grupoSelecionado.id < 0 ? 'post': 'put', 
            url: `/${props.nomeController}/${data.value.grupoSelecionado.id < 0 ? 'AddGrupo': 'UpdateGrupo'}`,
            data: data.value.grupoSelecionado
        }).then(response => {
            if (response.data.msgErro && response.data.msgErro != "")
                $vistra.showMessage(response.data.msgErro, "error");
            else {
                data.value.grupoSelecionado.id = response.data.novoId
                // selecionarNovoGrupo(data.value.grupoSelecionado);
                $vistra.showMessage(response.data.msg);
            }
        }).catch(e => {
            $vistra.showMessage(!e.data.msgErro ? e : e.data.msgErro, "error");
        }).finally(() => {
            data.value.grupoSelecionado = []
            carregaGrupos()
            drawerAddOrEditGrupo.value.toggle();
        })                 
    }
}
const fecharModalGrupo = () => {
    data.value.grupoSelecionado = []
    carregaGrupos()
    drawerAddOrEditGrupo.value.toggle();
}
const onClickLimparImagem = () => {
    if(data.value.grupoSelecionado.imagem) {
        data.value.grupoSelecionado.imagem = null
    }
    if(data.value.dataSource.imagem) {
        data.value.dataSource.imagem = null
    }
}
const onCreated = () => {
    carregaGrupos()
    setColunas()
}
onCreated();
const abreDrawerGrupos = computed(() => {
    drawerGrupos.value?.toggle();
})

// #endregion
</script>

<template>
    <div id="pageGrupos">
        <Drawer
            ref="drawerGrupos" 
            size="lg"
            :visivel="abreDrawerGrupos"
            :showHeaderDrawer="false"
            :noPadding="true"
        >   
            <div
                class="drawer-head flex items-center p-6 border-b border-solid border-b-gray-300 dark:border-b-gray-700"
            >
                <div class="flex items-center">
                    <h4 class="text-black dark:text-white">{{ props.titulo }}</h4>
                </div>

                <button type="button" @click="$emit('resetarVisibilidade')" class="ml-auto">
                    <i
                        role="presentation"
                        class="dx-icon-close cursor-pointer text-lg text-black dark:text-white transition-all hover:text-primary-500"
                    ></i>
                </button>
            </div>
            <div
                class="flex items-center pl-6 pr-6 border-b border-solid border-b-gray-300 dark:border-b-gray-700"
            >
                <WrapperHead 
                    :button="$vistra.globalize('btn-novo')"
                    :title="filterRowVisible ? data.dataSource.length + ' ' +  $vistra.globalize('grupos') : ''"
                    @search="search"
                    @button="onInitNewRow"
                >
                </WrapperHead>
            </div>

            <dx-data-grid
                ref="refGrid"
                :data-source="data.dataSource"
                :columns="colunas"
                keyExpr="id"
                id="gridGrupos"
                :allowColumnResizing="allowColumnResizing"
                :paging="{ enabled: pagingEnabled }"
                :onRowClick="onRowClick"
                :show-borders="false"
				:allow-column-filter="true"
				:allow-column-reordering="true"
                :row-alternation-enabled="true"
            >
                <DxPager
                    :allowed-page-sizes="[10, 20, 50]"
                    :show-page-size-selector="true"
                    :show-navigation-buttons="true"
                />
            </dx-data-grid>
        </Drawer>

        <Drawer
            ref="drawerAddOrEditGrupo" 
            size="lg"
            container=".dx-viewport"
            pai=".dx-viewport"
            id="drawerAddOrEditGrupo"
            :title="data.grupoSelecionado.id < 0 ? $vistra.globalize('btn-novo') : $vistra.globalize('btn-atualizar')"
        >
            <div class="pb-6">
                <dx-validation-group ref="validador">
                    <div class="row">
                        <div class="col-12 form-group">
                            <dx-text-box
                                v-model="data.grupoSelecionado.nome"
                                ref="textBoxNomeGrupo"
                                labelMode="floating"
                                :label="$vistra.globalize('nome')"
                            >
                                <dx-validator 
                                    :validationRules="[{type: 'required'}]" 
                                />
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="pt-6" v-if="grupoTemImagem">
                        <div class="col-6 form-group">
                            <div class="flex justify-between pb-2 justify-items-center">
                                <label class="font-bold text-base">{{ $vistra.globalize("imagem") }}</label>
                                <i class="fa-regular fa-trash cursor-pointer rotulo dark:hover:text-primary-500 hover:text-black dark:text-white text-primary-500"
                                    style="font-size: 1.1rem;" :onClick="onClickLimparImagem"></i>
                            </div>
                            <a @click="onClick" class="cursor-pointer dark:hover:text-primary-500 hover:text-black dark:text-white text-primary-500">
                                <div class="border border-solid border-gray-300 dark:border-gray-700 p-2">
                                    <div class="border border-dashed border-gray-300 dark:border-gray-700 hover:text-primary-500 rounded p-8">
                                        <dx-button 
                                            v-if="!data.grupoSelecionado.imagem"
                                            :text="$vistra.globalize('selecione-imagem')"
                                            :hint="$vistra.globalize('selecione-imagem-32px-hint')"
                                            icon="upload"
                                        >                    
                                        </dx-button>
                                        <img 
                                            v-if="data.grupoSelecionado.imagem"
                                            ref="imagemEdicao" 
                                            :src="!!data.grupoSelecionado.imagem ? `data:image/png;base64,${data.grupoSelecionado.imagem}` : ''" 
                                            :style="{ visibility: !!data.grupoSelecionado.imagem ? 'visible' : 'hidden' }" 
                                            class="imagem-grupo"
                                        />
                                    </div>
                                </div>
                            </a>
                        </div>         
                    </div>
                </dx-validation-group>
            </div>
            <div class="flex items-center justify-end p-6 border-t border-solid border-t-gray-300 dark:border-t-gray-700">
                <DxButton
                    :text="$vistra.globalize('btn-cancelar')"
                    type="normal"
                    styling-mode="outlined"
                    class="mr-4"
                    @click="fecharModalGrupo"
                    />
    
                <DxButton
                    :text="data.grupoSelecionado.id < 0 ? $vistra.globalize('btn-novo') : $vistra.globalize('btn-atualizar')"
                    type="submit"
                    styling-mode="contained"
                    @click="salvarGrupo"
                />
            </div>
        </Drawer>
    </div>
</template>

<style lang="scss">
#pageGrupos {
    z-index: 9999 !important;
  @import '@/styles/base.scss';
  #grupoTitle {
    @apply w-[50%] #{!important};
  }
}
#drawerAddOrEditGrupo {
  @import '@/styles/base.scss';
}
.imagem-grupo img {
    width: 32px;
    height: 32px;
}
#gridGrupos {
    @apply p-5 #{!important};
}
#pageGrupos .dx-datagrid-rowsview .dx-datagrid-content .dx-datagrid-table tbody .dx-row td:first-of-type:not(.dx-datagrid-expand){    
    @apply p-0 pl-6 #{!important};
}
</style>